__turbopack_context__.v({
  "goToHome": "not-found-module-sass-module__qw9G7G__goToHome",
  "leftBubble": "not-found-module-sass-module__qw9G7G__leftBubble",
  "leftBubbleAnimate": "not-found-module-sass-module__qw9G7G__leftBubbleAnimate",
  "leftBubbleContentAnimate": "not-found-module-sass-module__qw9G7G__leftBubbleContentAnimate",
  "notFoundLogo": "not-found-module-sass-module__qw9G7G__notFoundLogo",
  "notFoundPage": "not-found-module-sass-module__qw9G7G__notFoundPage",
  "notFoundPageContent": "not-found-module-sass-module__qw9G7G__notFoundPageContent",
});
